import { css, type Theme } from "@emotion/react";

const navHeight = "7rem";

export const stickyNavigation = css`
  height: ${navHeight};
`;

export const mainNav = css`
  height: ${navHeight};
`;

export const leftContent = css`
  height: 100%;
  display: flex;
  align-items: center;
`;

export const link = css`
  display: inline-flex;
  height: 100%;
  align-items: center;
`;

export const logo = css`
  display: block;
  width: 100%;
  max-width: 10.375rem;
`;

export const rightContent = css`
  flex: 0 1 66.5rem;
`;

export const nav = css`
  flex-flow: column;
  height: 100%;
  margin-left: 1rem;
  gap: 0.5rem;
`;

export const centeredWithoutGap = css`
  align-items: center;
  gap: 0;
`;

export const bottomNav = css`
  display: flex;
  justify-content: space-between;
`;

export const bottomNavLeft = css`
  display: flex;
  gap: 1.5rem;
`;

export const bottomNavRight = css`
  display: flex;
  flex-wrap: nowrap;
`;

export const dropdownButtonBorder = (theme: Theme) => css`
  &:hover,
  &:active,
  &:not(:last-of-type) {
    border-radius: 0;
    border-bottom: 0.125rem solid ${theme.system.borderHover};
    margin-top: calc(0.125rem / 4);
    button {
      background: none;
    }
  }
`;

export const dropdownButton = css`
  padding: 0;
  transition: none;
  border: none;
`;

export const dropdownContent = css`
  margin-top: 0.5rem;
  &:before {
    content: "";
    width: 100%;
    height: 0.5rem;
    background-color: transparent;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const withMargin = css`
  margin: 0.5rem 0;
  padding: 0;
`;

export const accountDropdownColumn = css`
  position: relative;
  left: 1rem;
`;
